import { BaseCard, type BaseCardProps } from "@/components/fragments/card/base-card";
import { VStack, HStack } from "@chakra-ui/react";
import { Button, type ButtonProps } from "@/components/essentials/button";
import { type ReactNode, type FC } from "react";
import { Typography } from "@/components/essentials/typography";
import { alertCardCancelButtonTestId, alertCardOkButtonTestId } from "./const";

export interface AlertCardProps extends Omit<BaseCardProps, "children"> {
  headerImage: ReactNode;
  headerMessage: string;
  message?: string;
  okButtonLabel: string;
  cancelButtonLabel: string;
  okButtonProps?: Omit<ButtonProps, "children">;
  cancelButtonProps?: Omit<ButtonProps, "children">;
}
export const AlertCard: FC<AlertCardProps> = ({
  headerImage,
  headerMessage,
  message,
  cancelButtonLabel,
  okButtonLabel,
  okButtonProps,
  cancelButtonProps,
  ...rest
}) => {
  return (
    <BaseCard {...rest}>
      <VStack spacing={3} justifyContent="center" alignItems="center">
        {headerImage}
        <Typography variant="display6">{headerMessage}</Typography>
        <Typography variant="text4" color="gray.dark">
          {message}
        </Typography>
        <HStack spacing={10}>
          <Button data-testid={alertCardCancelButtonTestId} styleVariant="mono" {...cancelButtonProps}>
            {cancelButtonLabel}
          </Button>
          <Button data-testid={alertCardOkButtonTestId} styleVariant="error" {...okButtonProps}>
            {okButtonLabel}
          </Button>
        </HStack>
      </VStack>
    </BaseCard>
  );
};
